<template>
  <transition appear name="fade">
    <div class="dialog">
      <div class="layer"></div>
      <div class="content">
        <h1>FOLLOW TO DOWNLOAD</h1>
        <iframe v-if="spotify" v-for="(item, index) in spotify" v-bind:key="index" :src="spotifyIframe(item)" width="300" height="56" scrolling="no" frameborder="0" style="border:none; overflow:hidden;" allowtransparency="true"></iframe>
        <iframe v-if="spotifyId" :src="spotifyIframeMain" width="300" height="56" scrolling="no" frameborder="0" style="border:none; overflow:hidden;" allowtransparency="true"></iframe>
        <button class="cancel" @click="close()">Cancel</button>
        <button class="close" @click="close()"></button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TrackEmbedFollow',
  dependencies: ['DATA'],
  props: ['spotify', 'close'],
  data () {
    return {
      spotifyId: this.DATA.configs.track.spotify_id
    }
  },
  computed: {
    spotifyIframeMain () {
      return `https://open.spotify.com/follow/1/?uri=${this.spotifyId}&size=detail&theme=dark`
    }
  },
  methods: {
    spotifyIframe (item) {
      return `https://open.spotify.com/follow/1/?uri=${item}&size=detail&theme=dark`
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/variables';
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .layer {
    background: $black;
    opacity: 0.8;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .content {
    padding: 50px;
    background: #191919;
    color: #9e9e9e;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-height: 500px;
    overflow: auto;

    h1 {
      color: $white;
      margin-bottom: 20px;
    }

    iframe {
      display: block;
      margin-bottom: 20px;
    }

    .cancel {
      margin-top: 20px;

      cursor: pointer;
      border: 1px solid #9e9e9e;
      background: transparent;
      outline: none;
      border-radius: 1em;
      font-size: 17px;
      padding: 5px 50px;
      color: #00ce34;
      margin: 0 auto;
      display: block;
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .close {
    cursor: pointer;
    border-color: transparent;
    outline: none;
    filter: invert(100%);
    background-color: transparent;
    background-size: cover;
    background-image: url('/static/images/close.svg');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    width: 25px;
    height: 25px;
    position: fixed;
    top: 10px;
    right: 10px;
    transition: transform 0.3s $easeOutBack;
    filter: invert(100%);
    &:hover {
      transform: scale(1.1);
    }
    &:active {
      transform: scale(0.9);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TrackEmbed/follow.vue